import React from 'react';
var ThemeContext = React.createContext();
export default ThemeContext;